import { SelectOptionType } from '@bp/ui-components';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const usePriorityOptions = () => {
  const { t } = useTranslation();

  return useMemo((): SelectOptionType[] => {
    return [
      {
        label: t('conditions.priority.optimizing'),
        value: 'OPTIMIZING',
        icon: 'OptimizingIcon',
      },
      {
        label: t('conditions.priority.important'),
        value: 'IMPORTANT',
        icon: 'ImportantIcon',
      },
      {
        label: t('conditions.priority.mandatory'),
        value: 'MANDATORY',
        icon: 'MandatoryIcon',
      },
    ];
  }, [t]);
};
